import { DataTable } from '@r/components/data-table/data-table.tsx';
import { useDataTable } from '@r/hooks/use-data-table.ts';
import { Fragment, type FC } from 'react';
import { CreateStepDialog } from './create-step-dialog.tsx';
import { useStepsColumns } from './hooks/use-steps-columns.tsx';
import { type LogicType, LogicTypes } from '@admin/types/workspace/logic.ts';
import type { LogicTypeStepWorkspaceWriteJsonMergePatchModel as Step } from '@r/api/generated/client.schemas.ts';

interface StepTableProps {
  data: Step[];
  setData: (type: LogicType, steps: Step[]) => void;
}

const EMPTY_STEPS: Step[] = [];

export const StepTable: FC<StepTableProps> = ({ data, setData }) => {
  const { table } = useDataTable({
    data: data ?? EMPTY_STEPS,
    columns: useStepsColumns(),
    pageCount: 1
  });

  const onCreated = async (step: Step) => {
    setData(LogicTypes.STEPS, [...data, step]);
  };

  return (
    <Fragment>
      <DataTable table={table} pagination={false} />
      <CreateStepDialog onStepCreated={onCreated} />
    </Fragment>
  );
};
